import axios, { isCancel } from '../axios';

export const getUploadsActionsList = async (params, signal) => {
  try {
    const res = await axios.get('uploads/actions', { params, signal });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const uploadUploadsFile = async (data, params) => {
  try {
    const res = await axios.postForm('uploads', data, {
      params,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getUploadsResult = async uploadId => {
  try {
    const res = await axios.get(`uploads/${uploadId}`);
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};

export const getUploadsTemplate = async action => {
  try {
    const res = await axios.get(`uploads/${action}/template`, {
      responseType: 'blob',
    });
    return res;
  } catch (error) {
    if (isCancel(error)) {
      console.log('Request cancelled...');
      return;
    } else {
      throw error;
    }
  }
};
